import { getNotificationDetails, showLoggerLogLevel } from '../notification-util';
/**
 * Shows the notification alert
 * @public
 */
export const showNotificationAlert = (configuration) => {
    showLoggerLogLevel(configuration);
    alert(getNotificationDetails(configuration));
};
